export default __webpack_public_path__ + "944592dc3bb17389d355224fee6efc11.png";